import bs from './languages/bs.json';
import en from './languages/en.json';

const translations: { [key: string]: { [key: string]: string } } = { bs, en };
export default translations;
